// extracted by mini-css-extract-plugin
module.exports = {"InfoMode":"InfoMode_InfoMode__3UaTE","cards":"InfoMode_cards__Dsk4K","header":"InfoMode_header__4aml8","warning":"InfoMode_warning__BXmKY"};